module.exports = __webpack_public_path__ + "static/media/066-boy-6.86755b6a.svg";